/*
 * TUMLE: Dawn pauses every video on the page when a modal (e.g. the product
 * image zoom) opens and closes (window.pauseAllMedia in global.js). Silent
 * background videos with autoplay, like the one in the "image with text"
 * rows, then stay frozen. After a modal closes, start those again.
 * Loaded by sections/main-product.liquid.
 */
(function () {
  function resume() {
    document.querySelectorAll('video[autoplay]').forEach((video) => {
      if (video.paused && video.muted) video.play().catch(() => {});
    });
  }

  // Dawn's ModalDialog.hide() dispatches this on <body>
  document.body.addEventListener('modalClosed', () => setTimeout(resume, 50));
})();
